const otpHandler = {
  init: function () {
    const otpTarget = $("#otp_target");

    if (otpTarget.length) {
      const otpLength = 6;
      const submitButton = $(".btn-signin");

      otpTarget.otpdesigner({
        length: otpLength,
        onlyNumbers: true,
        inputsClasses: "otp-input",
        onchange: function (code) {
          const realInput = $("#otp");

          if (!realInput.length) {
            return;
          }

          const sanitizedCode = String(code).replace(/[^0-9]/g, "");
          realInput.val(sanitizedCode || "");
          if (sanitizedCode.length === otpLength) {
            submitButton.removeAttr("disabled");
          } else {
            submitButton.attr("disabled", "disabled");
          }
        },
      });
    }
  },
};

$(function () {
  otpHandler.init();
});
